import React from "react";
import CrewMember from "./CrewMember";
import CrewTitle from "./CrewTitle";
import ViewRecordButton from "./ViewRecordButton";

class CrewLineup extends React.Component {
  renderViewRecordButton() {
    if (this.props.showViewRecordButton) {
      const containerStyle = {
        textAlign: "center",
        paddingTop: "1em",
        paddingBottom: "4em"
      };
      return (
        <div style={containerStyle}>
          <ViewRecordButton />
        </div>
      );
    }
    return null;
  }

  render() {
    const crewTeamArray = Object.keys(
      this.props.crewTeamModel
    ).map(memberId => {
      return {
        ...this.props.crewTeamModel[memberId]
      };
    });

    const membersContainerStyle = {
      position: "relative",
      height: "15em",
      marginTop: "2.3em" //should match offset of the middle combatant
    };

    return (
      <div>
        <div style={{textAlign: "center"}}>
          {/* Make only the text tappable - not the extra display:block space around it */}
          <CrewTitle
            isEditable={this.props.areCombatantsEditable}
            crewName={this.props.crewName}
          />
        </div>
        {this.renderViewRecordButton()}

        <div style={membersContainerStyle}>
          {crewTeamArray.map((member, i) => {
            return (
              <CrewMember
                key={i}
                showLaptop={this.props.showLaptop}
                position={member.arenaPosition}
                memberCount={crewTeamArray.length}
                memberId={member.memberId}
                name={member.name}
                rpgClass={member.class}
                skinId={member.skinId}
                loadoutTitle={member.loadoutTitle}
                isEditable={this.props.areCombatantsEditable}
                showClass={this.props.areCombatantsEditable}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

export default CrewLineup;



// WEBPACK FOOTER //
// ./src/b5-home/CrewLineup.js